export const DEFAULT_MANAGER_FILTERS = {
  search: '',
  status: '',
  dateFrom: '',
  dateTo: '',
};

export const hasActiveManagerFilters = (filters) =>
  Object.values(filters).some((value) => value !== '' && value != null);

export const filterManagers = (managers, filters) =>
  managers.filter((manager) => {
    if (filters.search) {
      const query = filters.search.toLowerCase().trim();
      const name = String(manager.name || '').toLowerCase();
      const email = String(manager.email || '').toLowerCase();
      if (!name.includes(query) && !email.includes(query)) {
        return false;
      }
    }

    if (filters.status && manager.status !== filters.status) {
      return false;
    }

    if (filters.dateFrom && manager.created_at) {
      const created = new Date(manager.created_at);
      const from = new Date(filters.dateFrom);
      if (created < from) return false;
    }

    if (filters.dateTo && manager.created_at) {
      const created = new Date(manager.created_at);
      const to = new Date(filters.dateTo);
      to.setHours(23, 59, 59, 999);
      if (created > to) return false;
    }

    return true;
  });
